import { FC } from 'react';
import { Container, Box } from '@mui/material';
import { EmailVerificationForm } from '@/components/Auth';

export const VerifyEmailPage: FC = () => {
  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '80vh',
          justifyContent: 'center',
        }}
      >
        <EmailVerificationForm />
      </Box>
    </Container>
  );
};
